import { render, staticRenderFns } from "./SubModuleSettingComponent.vue?vue&type=template&id=16a0435c&scoped=true&"
import script from "./SubModuleSettingComponent.vue?vue&type=script&lang=js&"
export * from "./SubModuleSettingComponent.vue?vue&type=script&lang=js&"
import style0 from "./SubModuleSettingComponent.vue?vue&type=style&index=0&id=16a0435c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a0435c",
  null
  
)

export default component.exports